import Vue from 'vue'
import { constructor } from 'tsyringe/dist/typings/types'
import { container, injectable, singleton } from 'tsyringe'
import _Component from './vue-class-component'
import { DecoratedClass, InjectedComponentOptions, VueClass } from './types'
import { array } from 'yup'

export {
  container as vcontainer,
  injectable as vservice,
  singleton as vsingleton,
  inject as vinject
} from 'tsyringe'

export function Component(target: any): any
export function Component<V extends Vue>(
  options: InjectedComponentOptions<V> & ThisType<V>
): <VC extends VueClass<V>>(target: VC) => DecoratedClass<VC>
export function Component(options) {
  if (typeof options === 'function') {
    return vcomponentFactory(options)
  }
  return function(Component) {
    return vcomponentFactory(Component, options)
  }
}

function vcomponentFactory(component: constructor<any>, options: any = {}) {
  injectable()(component)
  return _Component(options)(new Proxy(component, {
    construct(): object {
      return container.resolve(component)
    }
  }))
}

export function vmodule(): (target: constructor<any>) => any {
  return function(target) {
    singleton()(target)
    return class extends target {
      constructor() {
        super()
        return container.resolve(target)
      }
    }
  }
}
